import { getAddHyphensLowerCaseStr } from '../helpers'
import { API_BASE } from '../utils/constants';
import axios from 'axios';

export default class CoffeeShopService {

  _transformItem = data => {
    data["id"] = getAddHyphensLowerCaseStr(data["name"])
    return { ...data }
  }

  getResource = async url => {
    const res = await axios.get(`${API_BASE}${url}.json`)

    if (res.statusText !== 'OK') {
      throw new Error(`Could not fetch ${url}, recived ${res.status}`)
    }
    return await res.data
  }

  getItems = async items => {
    const res = await this.getResource(`/${items}/`)
    return res.map(this._transformItem)
  }

  getItem = async (items, itemId) => {
    const dataItems = await this.getResource(`/${items}/`)

    return dataItems
      .map(this._transformItem)
      .filter(({ id }) => id === itemId)
  }

  formSubmit = async (url, data) => {
    const res = await axios({
      url: `${url}.json`,
      method: 'post',
      data
    })

    if (res.statusText !== 'OK') {
      throw new Error(`Could not fetch ${url}, recived ${res.status}`)
    }
    return await res.data
  }
}